module.exports = __webpack_public_path__ + "img/financeiro.12084aa3.png";